import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { ShowsService } from 'src/app/services/shows.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-linking-shows',
  standalone: false,
  templateUrl: './linking-shows.component.html',
  styleUrl: './linking-shows.component.scss'
})
export class LinkingShowsComponent implements OnInit {

  linkedShows: any[] = [];
    processing = true;
    saving = false;

    searchResults: any[] = [];
searching = false;
searchError = false;
siteName = 'Pyrocast'
isPyrocast = true;
isIgnite = false;
isTune2 = false

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private showsService: ShowsService,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<LinkingShowsComponent>
    
  ) {}

  ngOnInit(): void {
    if (window.location.hostname == environment.skyDomain) {
          this.siteName = 'Skystream';
          this.isPyrocast = false;
          this.isIgnite = false;
        }
        else if (window.location.hostname == environment.tune2Domain || window.location.hostname == environment.tune2Domain2) {
          this.siteName = 'Tune2';
          this.isPyrocast = false;
          this.isTune2 = true;
          this.isIgnite = false;
        }
        else if (window.location.hostname == environment.igniteDomain) {
          this.siteName = 'IGNITE LIVE';
          this.isPyrocast = false;
          this.isTune2 = false;
          
        }
    this.getLinkedShows();
  }

  getLinkedShows(): void {

    this.showsService.getSingleShow(this.data.show.show_id).subscribe({
        next: (response: any) => {
          console.log('Single show response:', response);

          if ( response.linked_shows && response.linked_shows.length > 0) {
            this.linkedShows = response.linked_shows;
            this.processing = false;

            return;
          }

          this.initializeMainShow(response);
        },
        error: (error) => {
          console.error('Error loading linked shows:', error);
        }
      });
  }

  initializeMainShow(response: any): void {

    const mainShow = {
      show_id: response.show_id,
      label: '',
      sort_order: 100
    };

    this.showsService
      .updateLinkedShows(response.show_id, [mainShow]).subscribe({
        next: (putResponse: any) => {
          this.linkedShows = putResponse.linked_shows || [];
           this.getLinkedShows();
            
            
        },
        error: (error) => {
          console.error(
            'Error initializing main show:',
            error
          );
        }
        
      });
  }

  drop(event: CdkDragDrop<any[]>): void {
    if (event.previousIndex === event.currentIndex) {
      return;
    }
    moveItemInArray(this.linkedShows, event.previousIndex, event.currentIndex);
    this.calculateSortOrder(event.currentIndex);
  
  }

  calculateSortOrder(index: number): void {
    const currentShow = this.linkedShows[index];

    const previousShow = this.linkedShows[index - 1];

    const nextShow = this.linkedShows[index + 1];

    if (!previousShow) {

      //If there is a next show, put current show before it.//
      if (nextShow) { currentShow.sort_order = Number(nextShow.sort_order) / 2;

      } else {
        currentShow.sort_order = 100;
      }
      return;
    }

    if (!nextShow) {
      currentShow.sort_order = Number(previousShow.sort_order) + 100; 
      return;
    }
    currentShow.sort_order = ( Number(previousShow.sort_order) + Number(nextShow.sort_order) ) / 2;
  }

  removeLinkedShow(show: any): void {
    this.linkedShows = this.linkedShows.filter( item => item.show_id !== show.show_id );
  }

  save(): void {

     if (this.saving) {
    return;
  }

  this.saving = true;
    
    const linked_shows =
      this.linkedShows.map(show => ({
        show_id: show.show_id,
        label: show.label,
        sort_order: show.sort_order
      }));

    this.showsService.updateLinkedShows(this.data.show.show_id, linked_shows).subscribe({

        next: (response: any) => {
          console.log('Linked shows saved:', response);
           this.dialogRef.close(true);
           this.saving = false;

            this.snackBar.open(
          'Linked shows saved successfully',
          'Close',
          {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'bottom'
          }
        );
      

          this.linkedShows = response.linked_shows || [];
        },

        error: (error) => {
          console.error( 'Error saving linked shows:', error);
           this.saving = false;
          this.snackBar.open(
          'Unable to save linked shows. Please try again.',
          'Close',
          {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'bottom'
          }
        );
        }

      });
  }

  searchShows(searchTerm: string): void {
  const search = searchTerm.trim();

  this.searchResults = [];
  this.searchError = false;

  if (!search) {
    return;
  }

  this.searching = true;

  const currentShowCode =
    this.data?.show?.show_code ||
    this.data?.show?.shortened_show_id;

  this.showsService.searchLinkedShows(
    search,
    currentShowCode
  ).subscribe({
    next: (response: any[]) => {
      this.searchResults = response || [];
      this.searching = false;
    },

    error: (error) => {
      console.error('Error searching linked shows:', error);

      this.searchResults = [];
      this.searching = false;
      this.searchError = true;
    }
  });
}

addShowToLinkedShows(show: any): void {
  // Already linked check
  const alreadyExists = this.linkedShows.some(
    item => item.show_id === show.show_id
  );

  if (alreadyExists) {
    this.snackBar.open(
      'This show is already linked.',
      'Close',
      {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom'
      }
    );

    return;
  }

  const newShow = {
    show_id: show.show_id,
    show_name: show.show_name,
    show_code: show.show_code,
    label: '',
    sort_order: this.getNextSortOrder()
  };

  this.linkedShows.push(newShow);

  // Clear search results after selection
  this.searchResults = [];
}

getNextSortOrder(): number {
  if (this.linkedShows.length === 0) {
    return 100;
  }

  const sortOrders = this.linkedShows
    .map(show => Number(show.sort_order) || 0);

  return Math.max(...sortOrders) + 100;
}
}